/** Converts a number to currency format - i.e. commas, 2 decimal places. */
export const toCurrency = (value: number) => {
  return value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
